// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".background[data-v-313098b7]{background-image:url(https://thexo-cdn.nyc3.digitaloceanspaces.com/background.jpg);background-position:50%;height:100vh;background-size:cover}.overlay[data-v-313098b7]{background-color:rgba(0,0,0,.6);top:0;left:0;width:100%;height:100%;position:relative;z-index:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
